import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { FaTimes, FaFilter, FaInbox, FaMapMarkedAlt, FaBroadcastTower } from "react-icons/fa";
import ListGroup from 'react-bootstrap/ListGroup';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import { API } from 'aws-amplify';
import '../../../styles/compact-filters.css';
import '../../../components/PageHeader/PageHeader.css';
import PageHeader from '../../../components/PageHeader/PageHeader';
import { useI18n } from '../../../i18n';
import './AssetLocatorBridgeDeviceTest.css';
import Map from '../../../components/Map/Map';
import { getMapView } from '../../../theme/palette';
import { useDisplayMode } from '../../../theme/displayMode'; 

import pin_white from '../../../assets/images/white-pushpin.png';
import pin_orange from '../../../assets/images/orange-pushpin.png';
import pin_dgreen from '../../../assets/images/green-pushpin.png';
import pin_lightblue from '../../../assets/images/light-blue-pushpin.png';
import pin_lime from '../../../assets/images/lime-pushpin.png';
import pin_brown from '../../../assets/images/brown-pushpin.png';
import { ASSET_TYPE } from '../../../localdb';

let markers = [];

const hasImei = (asset) => asset.imei !== undefined && asset.imei !== null && String(asset.imei).trim() !== '';

const lastSeenTone = (value) => {
    if (!value) return 'none';
    const then = new Date(value).getTime();
    if (Number.isNaN(then)) return 'none';
    const hours = (Date.now() - then) / 3600000;
    if (hours < 6) return 'recent';
    return 'stale';
};

const SIGNAL_GAP_MS = 48 * 60 * 60 * 1000;

const missingSignal = (asset) => {
    if (!hasImei(asset)) return false;
    if (!asset.bridge_last_seen) return true;
    const then = new Date(asset.bridge_last_seen).getTime();
    if (Number.isNaN(then)) return true;
    return Date.now() - then > SIGNAL_GAP_MS;
};

const formatLastSeen = (value) => {
    if (!value) return 'Not seen yet';
    const then = new Date(value).getTime();
    if (Number.isNaN(then)) return 'Not seen yet';
    const mins = Math.round((Date.now() - then) / 60000);
    if (mins < 1) return 'Last seen just now';
    if (mins < 60) return `Last seen ${mins} min ago`;
    const hours = Math.round(mins / 60);
    if (hours < 48) return `Last seen ${hours} hr ago`;
    const days = Math.round(hours / 24);
    return `Last seen ${days} days ago`;
};

async function addMarkers(map, links) {
    const google = window.google
    await google.maps.importLibrary("marker");
    let infoWindow
    markers = [];
    // setMapOnAll(null);
    links.forEach((link, index) => {
      const wrap = document.createElement('div');
      wrap.style.position = 'relative';
      wrap.style.width = '32px';
      wrap.style.height = '32px';
      const icon = document.createElement('img');
      icon.src = link.icon;
      icon.style.width = '32px';
      icon.style.height = '32px';
      wrap.appendChild(icon);
      if (link.noSignal) {
        const badge = document.createElement('div');
        badge.textContent = '!';
        badge.title = 'No signal in the last 48 hours';
        badge.style.position = 'absolute';
        badge.style.top = '-6px';
        badge.style.right = '-8px';
        badge.style.width = '16px';
        badge.style.height = '16px';
        badge.style.borderRadius = '50%';
        badge.style.background = '#c53030';
        badge.style.color = '#fff';
        badge.style.fontSize = '11px';
        badge.style.fontWeight = '700';
        badge.style.lineHeight = '16px';
        badge.style.textAlign = 'center';
        badge.style.boxShadow = '0 0 0 2px #fff';
        wrap.appendChild(badge);
      }
      const marker = new window.google.maps.marker.AdvancedMarkerElement({
        map,
        position: link.coords,
        title: link.noSignal ? 'No signal in the last 48 hours' : link.title,
        content: wrap
      })
      marker.addListener(`click`, () => {
        if (infoWindow !== void 0) {
          infoWindow.close();
        }
        
        // create new window
        var infoWindowOptions = {
            content: link.content
        };
        infoWindow = new window.google.maps.InfoWindow(infoWindowOptions);
        infoWindow.open(map, marker);
  
      }) 

      markers.push({
        id: link.id,
        marker: marker
        })
    })

  }


const AssetLocatorBridgeDeviceTest = (props) => {
    const { t } = useI18n();
    const { theme } = useDisplayMode();
    const mapView = getMapView();
	const [assets, setAssets] = useState([]);
	const [assetList, setAssetList] = useState([]);
	
	const [district, setDistrict] = useState('');
	const [siteRef,setSiteRef] = useState('');
	const [siteAddress,setSiteAddress] = useState('');
	const [imeiQuery, setImeiQuery] = useState('');
	const [assetType,setAssetType] = useState('');
	const [bridgeDevicesOnly, setBridgeDevicesOnly] = useState(false);
	const [legendTypes, setLegendTypes] = useState([]);
	const [noSignalOnly, setNoSignalOnly] = useState(false);
	const [selectedId, setSelectedId] = useState('');
	const [isLoading, setIsLoading] = useState(false);
    const [mapTasks, setMapTasks] = useState([]); 
	const [districtList, setDistrictList] = useState([]);


    // GMaps icons
    // https://sites.google.com/site/gmapsdevelopment/

    const pin_yellow = "https://maps.google.com/mapfiles/ms/micons/ylw-pushpin.png";
    const pin_blue = "https://maps.google.com/mapfiles/ms/micons/blue-pushpin.png";
    const pin_green = "https://maps.google.com/mapfiles/ms/micons/grn-pushpin.png";
    const pin_ltblue = "https://maps.google.com/mapfiles/ms/micons/ltblu-pushpin.png";
    const pin_pink = "https://maps.google.com/mapfiles/ms/micons/pink-pushpin.png";
    const pin_purple = "https://maps.google.com/mapfiles/ms/micons/purple-pushpin.png";
    const pin_red = "https://maps.google.com/mapfiles/ms/micons/red-pushpin.png";

    const arrMarker = [pin_yellow, pin_blue, pin_green, pin_ltblue, pin_pink, pin_red, pin_purple, 
                        pin_orange, pin_dgreen, pin_lightblue,pin_lime,pin_brown,pin_white];

    const params = { 
        headers: {
            'x-api-key': process.env.REACT_APP_API_KEY,        
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    }

    // Load asset 
    useEffect(()=>{
        const fetchAssets = async () => {
            setIsLoading(true);        
            const assets = await API.get('asset_locator','/', params)
            
            for (let i = 0; i < assets.length; i++) {
                if (assets[i].hp_site === true) {
                    assets[i].hp_site_str = "High"
                }else{
                    assets[i].hp_site_str = "Low"
                }

                if (!assets[i].type) assets[i].type = ""
                if (!assets[i].district) assets[i].district = ""
        
                  	
            }
			assets.sort((a, b) => (a.site_ref > b.site_ref) ? 1 : -1)

			setAssets(assets);
            setAssetList(assets);
            setIsLoading(false);
        }
        fetchAssets();
              			
        }, []);
    
    // Load district
	useEffect(()=>{
		const fetchDistrict = async () => {
			
			const districts = await API.get('settings','/DISTRICTS', params)
			// districts.values.sort((a, b) => (a > b) ? 1 : -1)

			const unique = [...new Set((districts.values || []).filter(Boolean))];
			const list = unique.map((name) => (
				<option key={name} value={name}>{name}</option>
			));

			setDistrictList(list);
		}
		fetchDistrict();	 
    }, []);
    
    // Bridge device / last-seen UI only makes sense when this environment has IMEIs on assets
    const bridgeDeviceCount = assets.filter(hasImei).length;
    const bridgeFeatureEnabled = bridgeDeviceCount > 0;

    // Load map 
    useEffect(()=>{
        let link = []
        for (let i = 0; i < assetList.length; i++) {

            let lat = 0;
            let long = 0;
            if (assetList[i].latitude) {
                lat = parseFloat(assetList[i].latitude)
            }
            if (assetList[i].longitude){
                long = parseFloat(assetList[i].longitude)
            }  

            switch (assetList[i].type) {                   
                case ASSET_TYPE[0]: 
                    assetList[i].icon = arrMarker[0]; 
                    break;  
                case ASSET_TYPE[1]: 
                    assetList[i].icon = arrMarker[1]; 
                    break; 
                case ASSET_TYPE[2]: 
                    assetList[i].icon = arrMarker[2]; 
                    break; 
                case ASSET_TYPE[3]: 
                    assetList[i].icon = arrMarker[3]; 
                    break; 
                case ASSET_TYPE[4]: 
                    assetList[i].icon = arrMarker[4]; 
                    break; 
                case ASSET_TYPE[5]: 
                    assetList[i].icon = arrMarker[5]; 
                    break;    
                case ASSET_TYPE[6]: 
                    assetList[i].icon = arrMarker[6]; 
                    break;              
                case ASSET_TYPE[7]: 
                    assetList[i].icon = arrMarker[7]; 
                    break;                  
                case ASSET_TYPE[8]: 
                    assetList[i].icon = arrMarker[8]; 
                    break;  
                case ASSET_TYPE[9]:
                    assetList[i].icon = arrMarker[9]; 
                    break;   
                case ASSET_TYPE[10]:
                    assetList[i].icon = arrMarker[10]; 
                    break;  
                case ASSET_TYPE[11]:
                    assetList[i].icon = arrMarker[11]; 
                    break;  
                case ASSET_TYPE[12]:
                    assetList[i].icon = arrMarker[12]; 
                    break;                    
                default: 
                    assetList[i].icon = arrMarker[12];
            }

            // add marker to the map
            const noSignal = bridgeFeatureEnabled && missingSignal(assetList[i]);
            const seenLabel = formatLastSeen(assetList[i].bridge_last_seen);
            const seenColor = lastSeenTone(assetList[i].bridge_last_seen) === 'recent'
                ? '#1b7f3b'
                : lastSeenTone(assetList[i].bridge_last_seen) === 'stale'
                    ? '#b7791f'
                    : '#718096';
            const bridgeInfo = bridgeFeatureEnabled
                ? '<span class="text-dark">IMEI: '+ (hasImei(assetList[i]) ? assetList[i].imei : 'None') +'</span><br/>' +
                  '<span style="color:'+ seenColor +';font-weight:600">'+ seenLabel +'</span><br/>' +
                  (noSignal ? '<span style="color:#c53030;font-weight:700">No signal in the last 48 hours</span><br/>' : '')
                : '';
            link.push({
                id: assetList[i].assetId,
                coords: { lat: lat, lng: long }, 
                icon: assetList[i].icon,
                noSignal,
                content:'<div class="map-div">'+
                '<span class="map-link"><a href="/asset_det/'+ assetList[i].assetId +'">'+  assetList[i].site_ref  +'</a></span><br/>' +
                '<span class="text-dark">'+ assetList[i].site_address  +'</span><br/>' +
                bridgeInfo +
                '<br/>' +
                '<span class="text-dark"><strong>'+ assetList[i].district  +'</strong></span><br/>' +
                '<span class="text-dark">'+ assetList[i].type  +'</span><br/>' +
                '<span class="text-secondary small">Priority: '+ assetList[i].hp_site_str  +'</span>' +
                '</div>'     
                });
        }

        setMapTasks(link);

    }, [assetList, bridgeFeatureEnabled]);    

    const mapOptions = useMemo(() => ({
        center: mapView.center,
        zoom: mapView.zoom,
        scrollwheel: true,
        mapId: "4ada5c0171a1e340",
        colorScheme: theme === 'dark' ? 'DARK' : 'LIGHT',
    }), [theme, mapView.center.lat, mapView.center.lng, mapView.zoom]);

    const mapProps = {
        options: mapOptions,
        onMount: addMarkers,
        onMountProps: mapTasks,
        frameProps: mapTasks,
        fitToMarkers: true,
        className: 'gmaps',
    };

    const MemoMap = useCallback(<Map {...mapProps} />, [mapProps]) 

    
    const assetTypeList = Object.keys(ASSET_TYPE).map((item, i) => (
        <option key={"assetType"+i} value={ASSET_TYPE[item]}>{ASSET_TYPE[item]}</option>
    ));

    useEffect(() => {
		handleSearch();
        }, [district, siteRef, siteAddress, imeiQuery, assetType, bridgeDevicesOnly, legendTypes, noSignalOnly, assets]); 
        
    const handleClearSearch = () =>{
		setDistrict('');
        setSiteRef('');
        setSiteAddress('');
        setImeiQuery('');
        setAssetType('');
        setBridgeDevicesOnly(false);
        setLegendTypes([]);
        setNoSignalOnly(false);
	}

    const toggleLegendType = (type) => {
        setLegendTypes(current =>
            current.includes(type) ? current.filter(t => t !== type) : [...current, type]
        );
    }

    const clearLegend = () => {
        setLegendTypes([]);
        setNoSignalOnly(false);
    }

    const legendActive = legendTypes.length > 0 || noSignalOnly;
    
    const handleSearch = () => { 		
		let results = assets;

		if (bridgeDevicesOnly) {
			results = results.filter(hasImei);
		}

		// Legend (asset type pins)
		if (legendTypes.length > 0) {
			const wanted = legendTypes.map(t => t.toLowerCase());
			results = results.filter(item => wanted.some(t => item.type.toLowerCase().includes(t)));
		}

		// Legend (no signal in 48 hours)
		if (noSignalOnly) {
			results = results.filter(missingSignal);
		}

		// Site Reference
		if (siteRef){
            results = results.filter(results =>
                results.site_ref.toLowerCase().includes(siteRef.toLowerCase()) )
        }

        // Site Address
		if (siteAddress){
            results = results.filter(results =>
                results.site_address.toLowerCase().includes(siteAddress.toLowerCase()) )
        }

        if (imeiQuery) {
            const query = imeiQuery.trim();
            results = results.filter(item => hasImei(item) && String(item.imei).includes(query));
        }

		// District
		if (district){
			results = results.filter(results =>
				results.district.toLowerCase().includes(district.toLowerCase())
        )}
        
        // Asset Type
        if (assetType){
            if (assetType==="All Signs") {
                results = results.filter(results =>
                    results.type.toLowerCase().includes('school warning sign')  ||
                    results.type.toLowerCase().includes('sign - other') ||
                    results.type.toLowerCase().includes('periodic speed limit sign')
                )
            } else {
                results = results.filter(results =>
                    results.type.toLowerCase().includes(assetType.toLowerCase())      
                )              
            }
        }


		setAssetList(results);
		
    }

    const listedBridgeCount = assetList.filter(hasImei).length;
    const seenCount = assetList.filter(item => hasImei(item) && item.bridge_last_seen).length;
    const silentCount = listedBridgeCount - seenCount;

    const handleSelLocation = (item) =>{
        setSelectedId(item);
        const marker = markers.find(i => i.id === item)
        
        if (marker){
            // console.log(alert(marker.id))
            new window.google.maps.event.trigger( marker.marker, 'click' );
        }
    }


return (
    <div className="AssetLocator BridgeDevicesMap">

        <PageHeader
            title={bridgeFeatureEnabled ? t('pages.assetLocator.bridgeTitle') : t('pages.assetLocator.title')}
            breadcrumbs={[
                { label: t('nav.assets'), path: '/assets' },
                { label: bridgeFeatureEnabled ? t('pages.assetLocator.bridgeCrumb') : t('nav.assetLocator') },
            ]}
            count={!isLoading ? assetList.length : undefined}
            countLabel={bridgeDevicesOnly ? 'bridge devices' : 'assets'}
            subtitle={!bridgeFeatureEnabled
                ? 'All assets'
                : bridgeDevicesOnly
                    ? 'Assets with an IMEI that report bridge heartbeats'
                    : 'All assets — switch to Bridge Devices to focus on GPIO devices'}
        />
        <div className="row p-0 div-content">
            {bridgeFeatureEnabled && (
            <div className="col-12 view-toggle-bar">
                <div className="view-toggle">
                    <Button
                        type="button"
                        variant={!bridgeDevicesOnly ? 'primary' : 'outline-primary'}
                        className={`view-toggle-btn${!bridgeDevicesOnly ? ' is-active' : ''}`}
                        onClick={() => setBridgeDevicesOnly(false)}
                    >
                        All Sites
                    </Button>
                    <Button
                        type="button"
                        variant={bridgeDevicesOnly ? 'primary' : 'outline-primary'}
                        className={`view-toggle-btn${bridgeDevicesOnly ? ' is-active' : ''}`}
                        onClick={() => setBridgeDevicesOnly(true)}
                    >
                        <FaBroadcastTower className="view-toggle-icon" />
                        Bridge Devices
                        {!isLoading && (
                            <span className="view-toggle-count">{bridgeDeviceCount}</span>
                        )}
                    </Button>
                </div>
            </div>
            )}
            <div className="col-12 d-flex rounded bg-light p-2 compact-filters">
                <div className="col-md-6 p-1">
                    <div className="row w-100">
                    <div className="col-12 filters-title">
                        <FaFilter /> Filters
                        <Button variant="danger" className="clear-btn" onClick={handleClearSearch} title="Clear all filters">
                            <FaTimes /> Clear
                        </Button>
                    </div>
                    <div className="col-12 filters-row">
                    <Form.Group controlId="site_ref" className="filter-field">
                    <Form.Label>Site Ref</Form.Label>
                    <Form.Control
                        as="input"
                        value={siteRef}
                        placeholder="Search…"
                        onChange={e => {setSiteRef(e.target.value)}}
                        type="text" />
                    </Form.Group>
                    {bridgeFeatureEnabled && (
                    <Form.Group controlId="imei" className="filter-field">
                    <Form.Label>IMEI</Form.Label>
                    <Form.Control
                        as="input"
                        value={imeiQuery}
                        placeholder="Search…"
                        onChange={e => {setImeiQuery(e.target.value)}}
                        type="text" />
                    </Form.Group>
                    )}
                    <Form.Group controlId="site_address" className="filter-field filter-field-wide">
                    <Form.Label>Site Address</Form.Label>
                    <Form.Control
                        as="input"
                        value={siteAddress}
                        placeholder="Search…"
                        onChange={e => {setSiteAddress(e.target.value)}}
                        type="text" />
                    </Form.Group>
                    <Form.Group controlId="district" className="filter-field">
                        <Form.Label>District</Form.Label>
                        <Form.Control
                            as="select"
                            value={district}
                            onChange={e => {setDistrict(e.target.value)}}>
                                <option value=""></option>
                                {districtList}
                        </Form.Control>
                    </Form.Group>
                    <Form.Group controlId="assetType" className="filter-field">
                        <Form.Label>Asset Type</Form.Label>
                        <Form.Control
                            as="select"
                            value={assetType}
                            onChange={e => {setAssetType(e.target.value)}}>
                                <option value=""></option>
                                {assetTypeList}
                                <option value="All Signs">All Signs</option>
                        </Form.Control>
                    </Form.Group>
                    </div>
                    </div>
                </div>
                <div className="col-md-6 p-1 map-legend-light">
                    <div className="filters-title legend-title">
                        <FaMapMarkedAlt /> Map Legend
                        <span className="legend-hint">click to filter</span>
                        {legendActive && (
                            <button type="button" className="legend-reset" onClick={clearLegend}>
                                <FaTimes /> Show all
                            </button>
                        )}
                    </div>
                    <div className={`legend-items${legendActive ? ' legend-filtering' : ''}`}>
                        {ASSET_TYPE.map((type, i) => {
                            const active = legendTypes.includes(type);
                            return (
                            <button
                                type="button"
                                key={type}
                                className={`legend-item${active ? ' legend-item-active' : ''}`}
                                aria-pressed={active}
                                title={active ? `Remove ${type} filter` : `Show only ${type}`}
                                onClick={() => toggleLegendType(type)}
                            >
                                <img alt="" src={arrMarker[i]} width="12"/> {type}
                            </button>
                            );
                        })}
                        {bridgeFeatureEnabled && (
                        <button
                            type="button"
                            className={`legend-item legend-item-alert${noSignalOnly ? ' legend-item-active' : ''}`}
                            aria-pressed={noSignalOnly}
                            title={noSignalOnly ? 'Remove no-signal filter' : 'Show only bridge devices with no signal in 48 hours'}
                            onClick={() => setNoSignalOnly(v => !v)}
                        >
                            <span className="no-signal-badge">!</span> No signal in 48 hours
                        </button>
                        )}
                    </div>
                </div>
            </div>

            {(!isLoading) ? (
            <div className="col-12 d-flex p-0 bridge-layout">
                <div className={`bridge-list${bridgeFeatureEnabled ? '' : ' is-sites'}`}>
                    <div className="bridge-summary">
                        {!bridgeFeatureEnabled ? (
                            null
                        ) : bridgeDevicesOnly ? (
                            <>
                                <span className="bridge-chip recent">{seenCount} seen</span>
                                <span className="bridge-chip none">{silentCount} quiet</span>
                            </>
                        ) : (
                            <>
                                <span className="bridge-chip none">{assetList.length} sites</span>
                                <span className="bridge-chip bridges">{listedBridgeCount} bridge devices</span>
                            </>
                        )}
                    </div>
                    <div className="scroller">
                    {(assetList.length === 0) ? (
                        <div className="empty-state">
                            <FaInbox className="empty-state-icon" />
                            <div className="empty-state-text">No records found</div>
                            <div className="empty-state-subtext">Try adjusting the filters</div>
                        </div>
                    ):(
                    <ListGroup defaultActiveKey="#">
                        {assetList.map((item) => {
                            const isBridge = bridgeFeatureEnabled && hasImei(item);
                            const tone = isBridge ? lastSeenTone(item.bridge_last_seen) : 'site';
                            const quiet = isBridge && missingSignal(item);
                            return (
                        <ListGroup.Item className={`item${isBridge ? '' : ' item-plain'}${selectedId === item.assetId ? ' item-selected' : ''}${isBridge ? ' is-bridge' : ''}${quiet ? ' is-quiet' : ''}`} key={item.assetId} action onClick={()=>handleSelLocation(item.assetId)}>
                            <span className="item-top">
                                <span className="item-ref">
                                    {quiet && <span className="item-quiet-dot" title="No signal in the last 48 hours">!</span>}
                                    {item.site_ref}
                                </span>
                                {isBridge ? (
                                <span className={`item-seen item-seen-${tone}`}>
                                    {formatLastSeen(item.bridge_last_seen)}
                                </span>
                                ) : (
                                item.type ? <span className="item-type">{item.type}</span> : null
                                )}
                            </span>
                            {isBridge && (
                                <span className="item-imei">{item.imei}</span>
                            )}
                            <span className="item-address">{item.site_address}</span>
                        </ListGroup.Item>
                            );
                        })}
                    </ListGroup>
                    )}
                    </div>
                </div>
                <div className="bridge-map p-0 m-0">
                    {MemoMap}
                </div>
            </div>
            ):(
            <div className="col-md-12 loading-container">
                <div className="loading-content">
                    <Spinner animation="border" role="status" className="loading-spinner" />
                    <div className="loading-text">Loading assets...</div>
                    <div className="loading-subtext">Please wait while we fetch your data</div>
                </div>
            </div>
            )}
        </div>
    </div>
);
}

export default AssetLocatorBridgeDeviceTest;